<template>
  <div
    class="asc-aircraft-details-wrapper"
    data-automation-id="wrapper_aircraft_details"
  >
    <asc-accordion :value="1">
      <asc-accordion-item scrollbar first>
        <template slot="header">
          <asc-section-header :title="title"></asc-section-header>
        </template>
        <asc-details-list
          :values="values"
          :loading="loading"
        ></asc-details-list>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscSectionHeader from '@/components/atoms/AscSectionHeader'
import AscDetailsList from '@/components/molecules/AscDetailsList'

export default {
  name: 'AscAircraftDetailsWrapper',

  components: {
    AscAccordion,
    AscAccordionItem,
    AscSectionHeader,
    AscDetailsList,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-aircraft-details-wrapper {
  margin-bottom: 16px !important;
}
</style>
